export default "__VITE_PUBLIC_ASSET__911b050b__"